import InnerSwiper from '~/javascripts/components/User/ProfileMap/InnerSwiper';
import pluralize from 'pluralize';
import store from '~/javascripts/store.js';
import { Fragment } from 'react';
import { observer } from 'mobx-react';

const OuterSwiperSlides = observer(() => {
  const imageForCountry = (countryCode) => {
    const backgroundContent =
      store.projectDetailsMap.countryBackgroundImageUrls[countryCode] ||
      store.projectDetailsMap.countryBackgroundImageUrls['Default'];
    return backgroundContent;
  };

  return (
    <>
      {Array.from(store.projectDetailsMap.projectsList.entries()).map(
        ([countryCode, projects], index) => (
          <Fragment key={countryCode}>
            <div
              className='swiper-slide'
              data-country={countryCode}
              data-swiper-slide-index={index}
            >
              <div
                className='slide-inner'
                data-swiper-parallax-x='20%'
                style={{
                  '--background-image': `url(${imageForCountry(countryCode)})`,
                }}
              >
                <div className='main-slide-text font-mono md-w-2/5'>
                  <h2>
                    {store.projectDetailsMap.countryNameFromCode(countryCode)}
                  </h2>
                  <p className='leading-loose'>
                    {projects.length} {pluralize('projects', projects.length)}{' '}
                    supported
                  </p>
                </div>
                <InnerSwiper
                  parentSlideCountry={countryCode}
                  projects={projects}
                />
              </div>
            </div>
          </Fragment>
        )
      )}
    </>
  );
});
export default OuterSwiperSlides;
